import Mock from './mock';
import apolloClient from '../../utils/apollo-client';
import { getUserProfile as query } from '../graphql/user';
import { getEnv } from 'ecx.saigon.ui.common';

export default async function getUser() {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.getUserProfile;
  }
  const response = await apolloClient().then((client) =>
    client.query({
      query
    })
  );
  return response.data.getUserProfile;
}
